import React from "react";
import queryString from "query-string";
import { Form, Progress, Alert } from "reactstrap";

import { WithLocalize } from "../../containers/I18nProvider";
import { WithCaptcha } from '../../containers/captcha';

import logo from "./img/logo.png"

/**
 * Login Form Container
 *
 * @class LoginForm
 * @extends {React.Component}
 */
class LoginForm extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.parameters = queryString.parse(props.location.search);
    this.state = {
      onLogin: false,
      showForm: false,
      error: {
        open: false,
        message: "",
      },
      username: "",
      password: "",
    };
  }

  componentDidMount() {
    this.setState({ showForm: true });
  }

  onError(error) {
    this.setState({
      error: {
        open: true,
        message: error.message,
      },
    });
  }

  async onSubmit(ev) {
    ev.preventDefault();

    this.setState({
      onLogin: true,
      error: {
        open: false,
        message: "",
      },
    });



    this.props.api
      .userPassLogin(
        {
          username: this.usernameInput.value,
          password: this.passwordInput.value,
        },
        this.parameters
      )
      .then((response) => {
        this.setState({ onLogin: false });
        window.location =
          this.parameters.redirect_uri + "?" + queryString.stringify(response);
      })
      .catch((error) => {
        const translate = this.props.translate(error.errorCode);

        let message = ""

        if (translate) {
          message = translate;
        } else if (error.details) {
          message = error.details;
        }
        this.setState({
          onLogin: false,
          error: { open: true, message: message },
        });
      });
  }

  render() {
    const { translate } = this.props;

    return (
      <>
        <Form onSubmit={(event) => this.onSubmit(event)} className="alva-login">
          <div className="alva-wrapper">
            <div className="alva-form-group">
              <div className="alva-form-content">
                <div>
                  <img src={logo} alt="alva" />
                  <p className="title-alva">{translate("Title")}</p>
                </div>
                <div className="alva-form-container alva-form-container-login">
                  <input
                    disabled={this.state.onLogin}
                    placeholder={translate("PlaceholderUserName")}
                    ref={(ref) => {
                      this.usernameInput = ref;
                    }}
                    required={true}
                    tabIndex={1}
                    type="text"
                    autoCorrect="off"
                    autoCapitalize="none"
                    name="login"
                    id="login"
                    className="user-input-alva"
                  />
                </div>
                <div className="alva-form-container">
                  <input
                    required={true}
                    disabled={this.state.onLogin}
                    placeholder={translate("PlaceholderPassword")}
                    ref={(ref) => {
                      this.passwordInput = ref;
                    }}
                    tabIndex={1}
                    type="password"
                    autoCorrect="off"
                    autoCapitalize="none"
                    id="password"
                    name="login"
                    className="user-input-alva"
                  >
                  </input>
                </div>
                <div className="alva-button">
                  {!this.state.onLogin ? (
                    <button type="submit" disabled={!this.props.turnstileSuccess}>
                      <span className="alva-enter-text">
                        {translate("ButtonEnter")}
                      </span>
                    </button>
                  ) : (
                    <Progress animated color="danger" value={100} />
                  )}
                </div>
                <this.props.TurnstileComponent setTurnstileSuccess={this.props.setTurnstileSuccess} />
                <div className="messages-container">
                  <Alert
                    color="danger"
                    id="error-message"
                    isOpen={this.state.error.open}
                    toggle={() => this.setState({ error: { open: false } })}
                  >
                    {this.state.error.message}
                  </Alert>
                </div>
              </div>
            </div>
          </div>
        </Form>
      </>
    );
  }
}

export default WithCaptcha(WithLocalize(LoginForm), { useInsideForm: true, style: { marginTop: '2rem' } });
